const SourceSelectTick = ({ color }: any) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="7.50034"
        cy="7.50002"
        r="6.1682"
        transform="rotate(7.6846 7.50034 7.50002)"
        fill="white"
        stroke={color ? color : "#35D4AE"}
      />
      <path
        d="M5.78425 8.50631L7.84144 5.57378C7.99639 5.35289 8.30107 5.29944 8.52195 5.45439C8.72276 5.59526 8.78519 5.85986 8.67846 6.07277L8.64133 6.13491L6.26066 9.52859C6.10415 9.7517 5.79976 9.80032 5.58313 9.65017L5.5264 9.60428L4.3389 8.48992C4.14214 8.30529 4.13232 7.99611 4.31695 7.79936C4.4848 7.62049 4.75557 7.59611 4.95124 7.73188L5.00751 7.77742L5.78425 8.50631Z"
        fill={color ? color : "#35D4AE"}
      />
      <path
        d="M7.94769 8.55896L10.0049 5.62643C10.1598 5.40554 10.4645 5.35209 10.6854 5.50705C10.8862 5.64791 10.9486 5.91252 10.8419 6.12542L10.8048 6.18756L8.42409 9.58124C8.26758 9.80435 7.9632 9.85297 7.74656 9.70282L7.68984 9.65693L7.24095 9.31132C7.0442 9.12668 7.03437 8.81751 7.219 8.62076C7.38685 8.44189 7.65763 8.41751 7.85329 8.55327L7.90956 8.59881L7.94769 8.55896Z"
        fill={color ? color : "#35D4AE"}
      />
    </svg>
  );
};

export default SourceSelectTick;
